module.exports = __webpack_public_path__ + "img/location22.937b4194.png";